import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import { observer } from 'mobx-react';
// locals
import { HEADER_OVERVIEW_HEIGHT } from '..';
import { getCytobands } from './util';
// rounded rect from https://stackoverflow.com/a/45889603/2129219
// prettier-ignore
function rightRoundedRect(x, y, width, height, radius) {
  return "M" + x + "," + y + "h" + (width - radius) + "a" + radius + "," + radius + " 0 0 1 " + radius + "," + radius + "v" + (height - 2 * radius) + "a" + radius + "," + radius + " 0 0 1 " + -radius + "," + radius + "h" + (radius - width) + "z";
}
// prettier-ignore
function leftRoundedRect(x, y, width, height, radius) {
  return "M" + (x + radius) + "," + y + "h" + (width - radius) + "v" + height + "h" + (radius - width) + "a" + radius + "," + radius + " 0 0 1 " + -radius + "," + -radius + "v" + (2 * radius - height) + "a" + radius + "," + radius + " 0 0 1 " + radius + "," + -radius + "z";
}
var colorMap = {
  gneg: 'rgb(227,227,227)',
  gpos25: 'rgb(142,142,142)',
  gpos50: 'rgb(85,85,85)',
  gpos100: 'rgb(0,0,0)',
  gpos75: 'rgb(57,57,57)',
  gvar: 'rgb(0,0,0)',
  stalk: 'rgb(127,127,127)',
  acen: '#800'
};
export default observer(function Cytobands(_ref) {
  var overview = _ref.overview,
    block = _ref.block,
    assembly = _ref.assembly;
  var offsetPx = block.offsetPx,
    reversed = block.reversed;
  var cytobands = getCytobands(assembly, block.refName);
  var coords = cytobands.map(function (f) {
    var refName = f.refName,
      start = f.start,
      end = f.end,
      type = f.type;
    return [overview.bpToPx({
      refName: refName,
      coord: start
    }), overview.bpToPx({
      refName: refName,
      coord: end
    }), type];
  });
  var arr = cytobands || [];
  var lcap = reversed ? arr.length - 1 : 0;
  var rcap = reversed ? 0 : arr.length - 1;
  var firstCent = true;
  return React.createElement("g", {
    transform: "translate(-".concat(offsetPx, ")")
  }, coords.map(function (_ref2, index) {
    var _ref3 = _slicedToArray(_ref2, 3),
      start = _ref3[0],
      end = _ref3[1],
      type = _ref3[2];
    var key = "".concat(start, "-").concat(end, "-").concat(type);
    if (type === 'acen' && firstCent) {
      firstCent = false;
      return React.createElement("polygon", {
        key: key,
        points: [[start, 0], [end, HEADER_OVERVIEW_HEIGHT / 2], [start, HEADER_OVERVIEW_HEIGHT]].toString(),
        fill: colorMap[type]
      });
    }
    if (type === 'acen' && !firstCent) {
      return React.createElement("polygon", {
        key: key,
        points: [[start, HEADER_OVERVIEW_HEIGHT / 2], [end, 0], [end, HEADER_OVERVIEW_HEIGHT]].toString(),
        fill: colorMap[type]
      });
    }
    if (lcap === index) {
      return React.createElement("path", {
        key: key,
        d: leftRoundedRect(Math.min(start, end), 0, Math.abs(end - start), HEADER_OVERVIEW_HEIGHT, 8),
        fill: colorMap[type]
      });
    } else if (rcap === index) {
      return React.createElement("path", {
        key: key,
        d: rightRoundedRect(Math.min(start, end), 0, Math.abs(end - start) - 2, HEADER_OVERVIEW_HEIGHT, 8),
        fill: colorMap[type]
      });
    } else {
      return React.createElement("rect", {
        key: key,
        x: Math.min(start, end),
        y: 0,
        width: Math.abs(end - start),
        height: HEADER_OVERVIEW_HEIGHT,
        fill: colorMap[type]
      });
    }
  }));
});